export default {
  LIST_FETCHED: 'TEMPLATES_FETCHED',
  LIST_LOAD: 'TEMPLATE_LOAD',
  ITEM_DETAIL: 'TEMPLATE_DETAIL',
  BUTTON_LOAD: 'TEMPLATES_BUTTON_LOAD',
};
